
/** by MVinfo / Walcledson de Paula 16/10/24w
 * 
 * no PC manter o tamanho;
 * no Tablet ou Notebook com telas menores diminuir o tamanho do menu;
 * no celular, deve ficar grudado na parte inferior do celular;
 * 
* src/app/agendexColaborador/components/menu/pc_menu.jsx
*/

import React, { useState, useEffect, Component } from 'react';
import { Link, useNavigate } from "react-router-dom";
import { p_getUserData } from '../../../../Services/p_userutils';

import imgLogomarca from '../../../../Assets/agendex/logoagendexprestador.png';
import imgLogoMini from '../../../../Assets/agendex/iconLogoAgendex.png';
import Icon from '@mdi/react'; // icone do material design icones pra padronizar o home do mobile/desktop (delphi) no web 2/7/24w
import { mdiHome, mdiCalendarClock, mdiAccountCircle, mdiStoreCogOutline, mdiPlusNetworkOutline, mdiAccountMultipleCheck } from '@mdi/js'; // colaboradores

import './pc_menu.css';

function PCMenu(props) {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const navigate = useNavigate();

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const activeLink = "nav-link active";
    const inactiveLink = "nav-link text-black";

    const initialUserData = p_getUserData();
    const [tipoAtendimento, setTipoAtendimento] = useState(initialUserData.tipoAtendimento); // 0 = não possui colaboradores, 1 = possui colaboradores



    return (
        <>
            {/* Menu lateral esquerdo para telas maiores */}
            <div className={`d-flex flex-column flex-shrink-0 text-bg-white ${isMobile ? 'd-none' : 'p-3 bg-white'}`} id="menu">
                <a href="/app/colaborador/home" className="d-flex align-items-center mb-3 mb-md-0 me-md-auto text-white text-decoration-none">
                    <img src={isMobile ? imgLogoMini : imgLogomarca} className="img-logo" alt="logo" /><br/>
                </a>
                <p></p>
                <ul className="nav nav-pills flex-column mb-auto">
                    <hr/>
                    <li className="nav-item">
                        <Link to="/app/colaborador/home" className={props.page === "home" ? activeLink : inactiveLink} aria-current="page">
                            <Icon path={mdiHome} size={1} className='me-2'
                                title="Página principal/Dashboard do Colaborador"/>Home
                        </Link> 
                    </li>

                    {/* ******* menu agendamentos ******** */}
                    <li className="nav-item dropdown">
                        <a className="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                            {/* <i className="bi bi-calendar"></i><span className="ms-1 d-none d-sm-inline">Agendamentos</span> */}
                            <Icon path={mdiCalendarClock} size={1}
                                title="ver meus agendamentos (abertos, concluídos, excluídos e pendentes)"/> Agendamentos
                        </a>
                        <ul className="dropdown-menu">
                            <li>
                                <Link to="/app/colaborador/agendamentos/abertos" className={props.page === "agendamentosabertos" ? activeLink : inactiveLink} aria-current="page">
                                    <i className="bi bi-calendar2-date-fill"></i> <span className="ms-1 d-none d-sm-inline menu-title">Abertos</span>
                                </Link>
                            </li>
                            <li>
                                <Link to="/app/colaborador/agendamentos/concluidos" className={props.page === "agendamentosconcluidos" ? activeLink : inactiveLink}>
                                    <i className="bi bi-check2-circle"></i> <span className="ms-1 d-none d-sm-inline menu-title">Concluídos</span>
                                </Link>
                            </li>
                            <li>
                                <Link to="/app/colaborador/agendamentos/excluidos" className={props.page === "agendamentosexcluidos" ? activeLink : inactiveLink}>
                                    <i className="bi bi-x-circle"></i> <span className="ms-1 d-none d-sm-inline menu-title">Excluídos</span>
                                </Link>
                            </li>
                            <li>
                                <Link to="/app/colaborador/agendamentos/pendentes" className={props.page === "agendamentospendentes" ? activeLink : inactiveLink}>
                                    <i className="bi bi-clock"></i> <span className="ms-1 d-none d-sm-inline menu-title">Pendentes</span>
                                </Link>
                            </li>
                        </ul>
                    </li>
                    {/* ******* menu agendamentos ******** */}

                    {/* ******* menu perfil ******** */}
                    <li className="nav-item">
                        <Link to="/app/colaborador/perfil" className={props.page === "perfil" ? activeLink : inactiveLink} aria-current="page">
                            <Icon path={mdiAccountCircle} size={1} 
                                title="Acessar seus dados pessoais"
                            /> Perfil
                        </Link> 
                    </li>
                    {/* ******* menu perfil ******** */}
                </ul>
            </div>

            {/* Menu horizontal inferior para dispositivos móveis */}
            {isMobile && (
                <div className="bottom-menu d-flex justify-content-between align-items-center bg-light p-1 fixed-bottom" style={{ height: '50px' }}>
                    {/* Botões do menu horizontal */}
                    <Link to="/app/colaborador/home" className={props.page === "home" ? activeLink : inactiveLink}>
                        <Icon path={mdiHome} size={1}
                            title="Página principal/Dashboard"/>
                    </Link>

                    {/* ******* menu agendamentos ******** */}
                    <div className="dropdown">
                        <a className={`nav-link dropdown-toggle ${props.page.startsWith("agendamentosabertos") ? activeLink : inactiveLink}`} href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                            <Icon path={mdiCalendarClock} size={1}/>
                        </a>

                        <ul className="dropdown-menu">
                            <li>
                                <Link to="/app/colaborador/agendamentos/abertos" className={props.page === "agendamentosabertos" ? activeLink : inactiveLink} aria-current="page">
                                    <i className="bi bi-calendar2-date-fill"></i> <span className="ms-1 d-sm-inline menu-title">Abertos</span>
                                </Link>
                            </li>
                            <li>
                                <Link to="/app/colaborador/agendamentos/concluidos" className={props.page === "agendamentosconcluidos" ? activeLink : inactiveLink}>
                                    <i className="bi bi-check2-circle"></i> <span className="ms-1 d-sm-inline menu-title">Concluídos</span>
                                </Link>
                            </li>
                            <li>
                                <Link to="/app/colaborador/agendamentos/excluidos" className={props.page === "agendamentosexcluidos" ? activeLink : inactiveLink}>
                                    <i className="bi bi-x-circle"></i> <span className="ms-1 d-sm-inline menu-title">Excluídos</span>
                                </Link>
                            </li>
                            <li>
                                <Link to="/app/colaborador/agendamentos/pendentes" className={props.page === "agendamentospendentes" ? activeLink : inactiveLink}>
                                    <i className="bi bi-clock"></i> <span className="ms-1 d-sm-inline menu-title">Pendentes</span>
                                </Link>
                            </li>
                        </ul>
                    </div>
                    {/* ******* menu agendamentos ******** */}


                    {/* ******* menu perfil ******** */}
                    <Link to="/app/colaborador/perfil" className={props.page === "perfil" ? activeLink : inactiveLink} aria-current="page">
                        <Icon path={mdiAccountCircle} size={1} 
                            title="Acessar seus dados pessoais"
                        />
                    </Link> 
                    {/* ******* menu perfil ******** */}
                </div>
            )}
        </>
    );
}

export default PCMenu;